/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAufgabeHandbackRequestDto } from '../../models/lexplus-aufgabe-handback-request-dto';
import { LexplusRequestHandbackDto } from '../../models/lexplus-request-handback-dto';

export interface AufgabenControllerRequestHandbackV1$Params {
  id: number;
      body: LexplusRequestHandbackDto
}

export function aufgabenControllerRequestHandbackV1(http: HttpClient, rootUrl: string, params: AufgabenControllerRequestHandbackV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAufgabeHandbackRequestDto>> {
  const rb = new RequestBuilder(rootUrl, aufgabenControllerRequestHandbackV1.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAufgabeHandbackRequestDto>;
    })
  );
}

aufgabenControllerRequestHandbackV1.PATH = '/v1/aufgaben/{id}/handback';
